
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import SelectBase from '@/components/atoms/SelectBase.vue'
import { SelectItem } from '@/models/SelectItem'

/**
 * プルダウンセレクト
 *
 * ボタン部分に関してはslotに持たせ、呼び出し元（親）にて実装する
 */
@Component({
  components: {
    SelectBase,
  },
})
export default class SelectPulldown extends Vue {
  /** セレクト部品 */
  @Ref()
  selectBase!: SelectBase

  /** オプション情報 */
  @Prop()
  private options!: SelectItem[]

  /** オプションの初期選択値 */
  @Prop()
  private optionDefault?: string | undefined

  /**
   * 選択中の値
   *
   * @returns 選択中のオプションコード
   */
  public selectedValue(): string {
    return this.selectBase.selectedValue
  }

  /**
   * 選択中のオプションのデータを返す
   *
   * @returns 選択中のオプション情報
   */
  public getOptionLabel(): string {
    const selectedOption = this.options.find((item) => {
      return item.value === this.selectedValue()
    })

    return selectedOption?.label || ''
  }

  /**
   * チェンジイベントの発火を親コンポーネントに通知する
   *
   * @param event イベントオブジェクト
   */
  private changeEvent(event: Event): void {
    this.$emit('change', event)
  }
}
